import React from 'react';
import ScreenComponent from './ScreenComponent';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../actions';
import '../../styles/elements/screen.scss';
import '../../styles/screens/integrations.scss';
import TranslationService from "../../app/services/TranslationService";
import axios from "axios";
import {config} from "../../app/config";
import {Button} from "../icymat-design/Button";


class PressCenterClass extends ScreenComponent
{
    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== this.getScreenName() && this.props.view === this.getScreenName()) {
            // this.loadNotes();
        }
    };

    getScreenName() {
        return 'press-center';
    };

    loginIntoPressCenter = () => {
        this.props.preloaderShow();
        let that = this;

        axios.get(config.apiAddress + '/module/press-center/token')
            .then(function (response) {
                window.open(that.getAddress() + '/press-center/login?token=' + response.data.token, '_blank').focus();
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'menu.press_center.actions.token_failed'));
                that.props.preloaderHide();
            });
    };

    getAddress() {
        if (this.props.user === null || this.props.user.domain === null) {
            return 'undefined';
        }

        let address = this.props.user.domain;

        if (address === null) {
            return 'undefined';
        }

        if (address.indexOf('.') < 0) {
            return document.location.protocol + '//' + address + '.' + document.location.hostname;
        }

        return document.location.protocol + '//' + address;
    }

    render() {
        /* eslint-disable */
        return (
            <div className="screen imd-text-accent" style={this.getStyle()} id="screen-integrations">
                <h1>{TranslationService.trans(this.props.language, 'menu.press_center')}</h1>

                <div>
                    <strong>{TranslationService.trans(this.props.language, 'press_center.address')}: </strong>
                    <a href={this.getAddress()} target="_blank">{this.getAddress()}</a>
                </div>

                <div>
                    <Button
                        color={'main'}
                        text={TranslationService.trans(this.props.language, 'press_center.sign_in')}
                        onClick={() => this.loginIntoPressCenter()}
                    />
                </div>
            </div>
        );
        /* eslint-enable */
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        view: state.view,
        user: state.user,
        language: TranslationService.getLanguage(state.user)
    }
};

export const PressCenterScreen = connect(mapStateToProps, {preloaderShow, preloaderHide, alert})(PressCenterClass);
